<template>
    <div class="relative z-0 flex justify-center inline-flight-booking">
      <flight-booking-form :show-close-btn="showCloseBtn" class="p-4"></flight-booking-form>
    </div>
</template>

<script>
export default {
  props: {
    showCloseBtn: {
      type: Boolean,
      default: false
    }
  }
};
</script>
